// https://cloud.tencent.com/document/product/1110/36841#pzcs
// import "../mock/index";
import Axios from "./utils/verifyHttp";
import { TYPE, ERROR_MESSAGE } from "./const";
import { arrayFind, on, promiseControl } from "./utils/index.js";
var NO_VERIFY = TYPE.NO_VERIFY, SLIDE = TYPE.SLIDE, IMAGE = TYPE.IMAGE;
var NOOP = function () { };
var Verify = /** @class */ (function () {
    function Verify(options) {
        // 传入参数
        this.imgElement = options.imgElement || null; // 图片对象
        this.defaultImgUrl = options.defaultImgUrl || null; // 默认图片
        this.verifyTypeRequest = options.verifyTypeRequest || function () { return Promise.reject({}); };
        this.captchaOption = options.captchaOption || {};
        // 事件
        this.onSuccess = options.onSuccess || NOOP; //验证成功后调用的触发的方法,data为后端所需要的数据	success(data)
        this.onLoad = options.onLoad || NOOP; //验证码加载成功后触发的方法，只有滑块验证码才可以获取captcha对象。
        this.onSlideClosed = options.onSlideClosed || NOOP; //滑块验证码正常关闭触发的方法。data（滑块验证码返回数据）	sliceClosed（data）
        this.onFail = options.onFail || NOOP; //验证码加载失败后触发的方法,失败后 type 为 2 图形验证码。errMsg为验证码的错误文案，data为具体返回的错误	type,errMsg, data
        this.onDownGrade = options.onDownGrade || NOOP; //滑块验证码降级成图片验证码时触发的方法
        this.onGetImgFail = options.onGetImgFail || NOOP; //手动点击图片切换图片验证码失败后的回调
        this.onTypeChange = options.onTypeChange || NOOP; //验证码类型变化时的回调
        // 内部数据
        this.isLoad = false; //是否已加载验证码。
        this.loadNeedVerify = false; //加载时是否需要验证
        this.captcha = null; //滑块验证码对象，可控制滑块验证码
        this.captchaAppid = ""; //滑块验证码的应用id
        this.type = NO_VERIFY; //具体操作
        this.beforeType = NO_VERIFY; //上次传入的具体操作
        this.sessionId = ""; //会话Id
        this.loading = false; //是否请求中
        this.isFristDownGrade = true; //是否首次降级，首次降级会出现图形验证码（详细见_initImgCode注释）
        this.imgData = {
            id: "",
            url: "",
            answer: ""
        };
        this.commonConfig = {
            env: options.env || null
        };
        this.initCaptcha();
    }
    /**
     * 初始化验证码组件, 不进行验证，即只会出现图形验证码或者加载腾讯滑块JS。
     */
    Verify.prototype.initCaptcha = function () {
        this._resetData();
        this.handleVerify({ isInit: true });
    };
    /**
     * 处理验证数据前的操作，验证成功后 handleLoad 会进行验证数据。
     */
    Verify.prototype.handleVerify = function (config) {
        var _this = this;
        var _a = config || {}, isInit = _a.isInit, imgCode = _a.imgCode;
        if (this.loading) {
            return;
        }
        this.loading = true;
        this.loadNeedVerify = !isInit;
        var needReload = isInit || !this.isLoad;
        this.verifyTypeRequest()
            .then(function (_a) {
            var appid = _a.appid, type = _a.type, sessionId = _a.sessionId;
            // appid需要为string类型
            appid = appid ? "".concat(appid) : appid;
            _this.imgData.answer = imgCode || "";
            // 如果类型修改，需要像初始化一样重新加载。
            if (_this.beforeType != type) {
                _this._resetData();
                needReload = true;
                // 如果是其他验证类型变成图形验证码，需要显示图形验证码，所以加载的时候先无需校验
                if (type == IMAGE) {
                    _this.loadNeedVerify = false;
                }
                _this.beforeType = type;
            }
            _this.captchaAppid = appid;
            _this.sessionId = sessionId;
            // this.type = type;
            _this.loading = false;
            _this._initImgElementEvent();
            if (type === SLIDE) {
                // 滑块验证码。
                _this._initSlideCaptcha();
            }
            else if (type === IMAGE) {
                // 图片验证码
                needReload ? _this._initImgCode() : _this.handleLoad(IMAGE);
            }
            else {
                // 默认不弹出时赋值
                _this.type = NO_VERIFY;
                _this.handleLoad(NO_VERIFY);
            }
        })
            .catch(function (err) {
            // TODO: 需要上报
            _this.loading = false;
        });
    };
    /**
     * 初始化时格式化数据
     */
    Verify.prototype._resetData = function () {
        this.isFristDownGrade = true;
        this.isLoad = false;
    };
    Verify.prototype._initImgElementEvent = function () {
        var getImgCode = this._getImgCode.bind(this);
        on(this.imgElement, "click", getImgCode);
    };
    /**
     * 验证验证码数据，调起滑块或者验证图片验证码是否成功
     */
    Verify.prototype._verifyData = function () {
        if (!this.isLoad) {
            return;
        }
        var type = this.type;
        if (type === SLIDE) {
            this.captcha.show();
        }
        else if (type === IMAGE) {
            this.verifyImgCode();
        }
        else {
            this.handleSuccess(NO_VERIFY);
        }
    };
    /**
     * 后台返回滑块时，无需滑块的情况
     * */
    Verify.prototype._needSlideCaptcha = function () {
        var UA = window.navigator.userAgent.toLowerCase();
        // 非小程序
        var IS_NOT_MINIPROGRAM = (!window.__wxjs_environment ||
            window.__wxjs_environment !== "miniprogram") &&
            UA.indexOf("miniprogram") === -1;
        // UA非xiaoeapp
        var IS_NOT_XIOAE_APP = UA.indexOf("xiaoeapp") === -1;
        // 且有滑块的应用ID
        var HAVE_APP_ID = !!this.captchaAppid;
        return IS_NOT_MINIPROGRAM && IS_NOT_XIOAE_APP && HAVE_APP_ID;
    };
    Verify.prototype._getUseCapcha = function () {
        var _a;
        return ((_a = window.__captchaInfo) === null || _a === void 0 ? void 0 : _a.FakeTencentCaptcha) || window.TencentCaptcha;
    };
    /**
     * 初始化滑块验证码
     * */
    Verify.prototype._initSlideCaptcha = function () {
        if (this._needSlideCaptcha()) {
            // 首先检查是否有 TencentCaptcha, 如果有就直接初始化
            var TcCaptcha = this._getUseCapcha();
            TcCaptcha ? this._initTencentCaptcha() : this._loadCapchaJs();
        }
        else {
            this.downGrade(ERROR_MESSAGE.NEED_DOWN_GRADE);
        }
    };
    /**
     * 初始化腾讯滑块
     * */
    Verify.prototype._initTencentCaptcha = function () {
        var _this = this;
        // 滑块验证码回调
        var captchaCallback = function (res) {
            // 滑块出错，自动降级。
            // 具体错误码 https://cloud.tencent.com/document/product/1110/36841
            if (res.errorCode) {
                _this.reportErrData("腾讯云滑块返回错误", res);
                _this.captcha.destroy();
                // 加载滑块验证码成功但是由于失败所以需要重新加载图片验证码。isLoad为false
                console.error("滑块验证码出错:", res);
                _this.downGrade(ERROR_MESSAGE.TENCENT_CAPTCHA_ERROR, res);
                return;
            }
            // 处理正常数据
            if (res.ret === 0) {
                var ticket = res.ticket, randstr = res.randstr;
                _this.handleSuccess(SLIDE, { ticket: ticket, randstr: randstr });
            }
            else if (res.ret === 2) {
                _this.handleSlideClosed(res);
            }
        };
        try {
            var TcCaptcha = this._getUseCapcha();
            var captcha = new TcCaptcha(this.captchaAppid, captchaCallback, {
                userLanguage: this.captchaOption.userLanguage
            });
            this.captcha = captcha;
            this.handleTypeChange(SLIDE);
            this.handleLoad(SLIDE, captcha);
        }
        catch (err) {
            this.reportErrData("初始化腾讯云滑块错误", err);
            // 初始化滑块验证码失败后降级
            this.downGrade(ERROR_MESSAGE.INIT_CAPTCHA_ERROR, err);
        }
    };
    /**
     * 加载腾讯滑块的JS代码
     * */
    Verify.prototype._loadCapchaJs = function () {
        var _a, _b, _c;
        var TENCENT_CAPTCHA_URL = ((_a = window.__captchaInfo) === null || _a === void 0 ? void 0 : _a.url) || "https://turing.captcha.qcloud.com/TCaptcha.js";
        var scriptElements = document.getElementsByTagName("script");
        var scriptArray = Array.prototype.slice.call(scriptElements);
        var that = this;
        var script = arrayFind(scriptArray, function (script) { return script.src === TENCENT_CAPTCHA_URL && !!script._vD; });
        if (window.TencentCaptcha) {
            return this._initTencentCaptcha();
        }
        if (!script) {
            // 没有就请求一个
            script = document.createElement("script");
            script.src = TENCENT_CAPTCHA_URL;
            var _d = promiseControl(), pms = _d[0], res = _d[1], rej = _d[2];
            script._vD = {
                promiseControl: { pms: pms, res: res, rej: rej }
            };
            document.body.appendChild(script);
            script.addEventListener("load", res);
            script.addEventListener("error", rej);
        }
        var scriptLoadPms = ((_c = (_b = script === null || script === void 0 ? void 0 : script._vD) === null || _b === void 0 ? void 0 : _b.promiseControl) === null || _c === void 0 ? void 0 : _c.pms) ||
            Promise.reject({
                msg: "script._vD.promiseControl.pms\u4E3A\u7A7A",
                _vD: script._vD
            });
        scriptLoadPms
            .then(function (_) {
            that._initTencentCaptcha();
        })
            .catch(function (err) {
            that.downGrade(ERROR_MESSAGE.LOAD_CAPCHA_JS_ERROR, err);
            that.reportErrData("加载腾讯云滑块JS文件失败", err);
            script.parentElement.removeChild(script);
        });
    };
    /**
     * 初始化图片验证码
     */
    Verify.prototype._initImgCode = function () {
        var _this = this;
        if (this.loading) {
            return;
        }
        this.handleTypeChange(IMAGE);
        this.loading = true;
        // 只有 0-主动点击 1-首次降级 2-首次加载验证码 3-加载验证码失败 的时候才会主动请求图片。
        Axios.post("api/get_img_verification", {
            session_id: this.sessionId
        }, this.commonConfig)
            .then(function (res) {
            if (res.code === 0) {
                var _a = res.data, id = _a.id, b64s = _a.b64s;
                _this.imgData.id = id;
                _this.imgData.url = b64s;
                if (_this.imgElement) {
                    _this.imgElement.src = b64s;
                }
                _this.handleLoad(IMAGE);
            }
            else {
                _this.handleFail(res.msg, res);
            }
            _this.loading = false;
        })
            .catch(function (error) {
            _this.handleFail("系统繁忙，请稍后再试", error);
            _this.loading = false;
        });
    };
    /**
     * 获取/刷新图形验证码
     * */
    Verify.prototype._getImgCode = function () {
        var _this = this;
        if (this.loading) {
            return;
        }
        this.loading = true;
        Axios.post("api/get_img_verification", {
            session_id: this.sessionId
        }, this.commonConfig)
            .then(function (res) {
            if (res.code === 0) {
                var _a = res.data, id = _a.id, b64s = _a.b64s;
                _this.imgData.id = id;
                _this.imgData.url = b64s;
                if (_this.imgElement) {
                    _this.imgElement.src = b64s;
                }
            }
            else {
                _this.handleGetImgFail(res.msg, res);
            }
            _this.loading = false;
        })
            .catch(function (error) {
            _this.handleGetImgFail("系统繁忙，请稍后再试", error);
            _this.loading = false;
        });
    };
    /**
     * 验证图片验证码需要获取传入的参数
     */
    Verify.prototype.verifyImgCode = function () {
        var _a = this.imgData, id = _a.id, answer = _a.answer;
        this.handleSuccess(IMAGE, {
            id: id,
            answer: answer
        });
    };
    /**
     * 滑块失败后降级
     */
    Verify.prototype.downGrade = function (errMsg, data) {
        if (data === void 0) { data = {}; }
        console.error("滑块错误", { errMsg: errMsg, data: data });
        this.onDownGrade(errMsg, data);
        // 首次降级才会更新图片验证码
        if (this.isFristDownGrade) {
            this._initImgCode();
            this.isFristDownGrade = false;
        }
        else {
            this.handleLoad(IMAGE);
        }
    };
    /**
     * 资源加载成功
     */
    Verify.prototype.handleLoad = function (type, captcha) {
        if (!this.isLoad) {
            this.isLoad = true;
            this.onLoad(type, captcha);
        }
        if (this.loadNeedVerify) {
            this._verifyData();
        }
    };
    /**
     * 滑块主动关闭
     * */
    Verify.prototype.handleSlideClosed = function (data) {
        this.onSlideClosed(data);
    };
    /**
     * 滑块或图片验证码成功的回调
     * */
    Verify.prototype.handleSuccess = function (type, data) {
        if (data === void 0) { data = {}; }
        if (data) {
            data.verification_type = type;
            data.session_id = this.sessionId;
        }
        this.onSuccess(data);
    };
    /**
     * 滑块和图片验证码都加载失败
     * */
    Verify.prototype.handleFail = function (errMsg, data) {
        // 失败后修改成图片，此时用户可以通过点击图片进行重试
        this.handleTypeChange(IMAGE);
        this.isLoad = false;
        if (this.imgElement) {
            this.imgElement.src = this.defaultImgUrl || "";
        }
        this.onFail(IMAGE, errMsg, data);
    };
    /**
     * 获取图形验证码失败
     */
    Verify.prototype.handleGetImgFail = function (errMsg, data) {
        if (this.imgElement) {
            this.imgElement.src = this.defaultImgUrl || "";
        }
        this.onGetImgFail(errMsg, data);
    };
    /**
     * 类型变化
     */
    Verify.prototype.handleTypeChange = function (curr) {
        if (curr != this.type) {
            var before = this.type;
            this.type = curr;
            this.onTypeChange(curr, before);
        }
    };
    ;
    Verify.prototype.reportErrData = function (type, err) {
        try {
            // window.sensors.track("error_reporting", {
            //   page_id: "",
            //   l_program: "",
            //   page_name: "",
            //   page_path: "",
            //   cmm1: "PC端",
            //   cmm2: this.captchaAppid || "", // 滑块应用ID
            //   cmm3: this.sessionId || "", // 校验使用的会话ID
            //   cmm4: JSON.stringify(err) || "",
            //   cmm5: type || ""
            // });
            console.log(type, err);
        }
        catch (error) {
            console.log(error);
        }
    };
    return Verify;
}());
export default Verify;
//# sourceMappingURL=main.js.map